import { useMutation, useQueryClient } from '@tanstack/react-query'

import type {
  CreateReservationRequest,
  CreateReservationResponse,
} from '../../types/reservation.js'

import { apiClient } from '../../lib/client.js'
import { writeReservationToken } from '../public-reservation/reservation-token.js'
import { meKeys } from './keys.js'

/**
 * Demande de réservation depuis l'espace client. La proposition réservée est
 * celle de l'URL — le serveur refuse un corps qui en désignerait une autre.
 */
export const useCreateMyReservationMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      responseId,
      ...request
    }: CreateReservationRequest & { responseId: string }) => {
      const response = await apiClient.client.post<CreateReservationResponse>(
        `/me/estimate-responses/${responseId}/reservation`,
        request
      )

      // Même jeton que par la voie publique : la page de confirmation est la
      // même, et elle ne doit rien redemander à qui vient de la déclencher.
      writeReservationToken(response.data.id, response.data.accessToken)

      return response.data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: meKeys.estimates })
    },
  })
}
